module.exports = __webpack_public_path__ + "static/red_slaad-7df5095449e04e4b94565e324e277e9d.jpeg";